var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOldlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296.92 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e7dfda;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #f1edea;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #e2d9d2;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #cfbfb4;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #e6ded8;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #f5f2f0;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #efeae7;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #efe9e6;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #622f0a;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #63300b;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #62300b;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #63300c;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #64320d;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #602d08;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #6c3d1b;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #704221;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #784c2d;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #6b3b19;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #5e2a04;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #5d2903;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #ab8f7c;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #5a2400;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #592200;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #5a2501;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #592300;\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #592401;\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #5c2701;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #5e2904;\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: #592301;\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: #5a2300;\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #5b2601;\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: #a98d79;\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: #5a2500;\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: #eae4df;\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: #947258;\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: #5c2702;\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: #dfd5cd;\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: #96755c;\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: #ddd2ca;\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: #ebe4e0;\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: #e4dcd6;\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: #5a2401;\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: #582201;\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: #5b2501;\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: #582100;\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: #572100;\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: #6b3b1c;\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: #6f401f;\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: #602c08;\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: #754829;\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: #f2eeec;\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: #ece6e1;\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: #f6f4f2;\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: #af9583;\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: #592400;\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: #64310d;\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: #e1d8d1;\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: #c2afa1;\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: #63310c;\r\n      }\r\n\r\n      .cls-60 {\r\n        fill: #efeae6;\r\n      }\r\n\r\n      .cls-61 {\r\n        fill: #cbbbaf;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M853,606a7.56,7.56,0,0,1,0-.83l-.07-.38a25.23,25.23,0,0,0,7,0l-.06.36a7.69,7.69,0,0,1,0,.83Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M919,605.16c0,.28,0,.56,0,.84h-6c0-.28,0-.56,0-.85l-.08-.37a18.4,18.4,0,0,0,6.06,0Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1103,605.18a5.64,5.64,0,0,1,0,.82h-6c0-.29,0-.58,0-.86l-.07-.39a18.07,18.07,0,0,0,6,.07Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M941,605.15c0,.28,0,.57,0,.85h-5c0-.28,0-.57,0-.85l-.06-.39a11.63,11.63,0,0,0,5,0Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1029,606a7.58,7.58,0,0,1,0-.83l-.06-.39a11.43,11.43,0,0,0,5,0l0,.39c0,.28,0,.57,0,.86Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M887,606h-4c0-.28,0-.55,0-.83h4C887,605.45,887,605.73,887,606Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1021,475c0,.28,0,.55.06.83l-4.07.41,0-.39a6,6,0,0,0,0-.85Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M970,606a7.5,7.5,0,0,1,0-.82l-.07-.37,4.06.37,0,.82Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1110,536h-.86v-3h.86Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M883,605.17c0,.28,0,.55,0,.83h-2a6.12,6.12,0,0,1,0-.85l-.07-.38Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M887,606c0-.27,0-.55,0-.82l2-.42-.06.39a6,6,0,0,1,0,.85Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1109.14,533v3c-1,5.24-4.47,8.16-9.11,10.08a21.12,21.12,0,0,1-6.08,1.71c-1.07-1.21-2.2-1.14-3.47-.22l.84.6-2.63,1.23c2.11,6.48,5,7.43,10.3,3.29,1.51-1.18,3-2.05,5-1.8a5.29,5.29,0,0,1,3.8,8.24c-3.35,4.71-7.61,8.31-13.78,8.73a4.78,4.78,0,0,0-5.94,0c-5.31-.33-8.57-3.73-11.52-8-3.33,4.28-7,7.71-12.56,8a6.38,6.38,0,0,0-6.93.09c-2.77.27-5.13-1.08-7.51-2-10.09,3.71-13.45,3-19-4.11-3,2.3-5.18,6-9.55,6.05a3.6,3.6,0,0,0-4.93,0c-5.7-1.44-8.43-5-9-11.83-.13-1.63,0-3.29.07-4.94,1.73-2.94.63-6.1.72-9.17.45-4.32.45-4.32-1.48-6l.84,6q-.5,3.66-1,7.32c-2,9-6.67,15.67-15.76,18.61a5.14,5.14,0,0,1-1.47,0,4.75,4.75,0,0,0-5.94,0c-4,.24-6.7-2.43-9.65-4.6a35.62,35.62,0,0,1-9.49,4.29c-6.8,1.74-11-1-11.76-8.17a56.53,56.53,0,0,1,.35-13.93,23.15,23.15,0,0,0,.22-7.28c-4.18,4.24-5.79,9.28-7.56,14.21-.32.92-.19,2-1.07,2.7-.33-.65-.75-1.06-1,0a1.45,1.45,0,0,0,.87,1.9c0,.66.09,1.33,0,2-.45,7.07-3.18,9.43-10.2,8.85a4.74,4.74,0,0,1-4.7-4.85,52,52,0,0,1,.13-6q1.49-28.12,3-56.26c.38-6.87,4.56-10.07,10.93-8.5,3.64.89,5.09,2.63,4.83,6.37a91.65,91.65,0,0,1-1.41,12.86c-.69,3.25.18,6.69-1.43,9.77-.32-.89.33-2-1-2.9.19,2.69-.9,5.27.77,7.66l.58,1.53c1.24-.92,2.36-1.82,3.55-2.6,7.48-4.93,16.23-1.28,17.94,7.49.64,3.3.2,6.62.07,9.93-.07,1.49-.08,3-.11,4.47-1.18,2.6-.82,5.22-.63,7.79,1.09.09,1.48-.13,1.72-.6h0c1.74-1,.69-2.08.1-3.15.08-6.41,1.32-12.49,4.69-18.09,5.71-9.45,18.68-13.72,28.6-5.75a46.09,46.09,0,0,1,11.57-3.74c5.3-1.19,8.78,1.19,9.73,6.54a33.2,33.2,0,0,1-.1,9c-.4,4.38-.73,8.78-.71,13.26,4.28-4.69,6.09-10.39,7.14-16.4.43-2.45.63-4.94.9-7.42a4.36,4.36,0,0,1,4.07-4.29c1-.14,2-.41,2.94-.56,5.46-.82,7.45.9,7.23,6.4-.19,4.65-.48,9.3-.76,14a35,35,0,0,0,.82,10.48,8.54,8.54,0,0,1,7.32-4.6c.54-1.64-.76-1.88-1.4-2.48a12.92,12.92,0,0,1,.72-20c6-4.59,12.73-5.43,19.82-3.05a9.11,9.11,0,0,1,6.11,6,1.5,1.5,0,0,0-.74,1.9c.24,1,.66.65,1,0,1,.84,1.45.6,2.24-.47a20,20,0,0,1,12.54-8.28C1099.24,521.78,1107.71,524.45,1109.14,533Zm-62,26.07c-1.47,1.65-3.33,1.05-5.11.9-.75-1.27-2.14-2.24-1.91-4,1.56-1,.92-2.26.52-3.69-.92,1-.45,2-.68,2.85-1-.92-.82-2.14-.87-3.28a148.11,148.11,0,0,1,.4-19c.15-1.6.81-3.23-.19-5-1.56.17-3.21-.26-4.82.77-.82,2.13,0,4.65-1.28,6.69l-.55-2.77c-.37,1.58-1.49,3.21.3,4.42.44,1.77-.91,3.28-.76,5-1.35,3.21-2.62,6.46-4.08,9.61a12.81,12.81,0,0,1-4.27,5.42c-3.29,2.25-6.49.92-6.76-3a47.83,47.83,0,0,1,.41-8.94c.52-4.31.61-8.62.75-12.94.06-2.11-.31-4-2.46-5,.44-.18.81-.41.54-1-1.28-.08-2.59-.4-3.87.3.77,1,1.88.39,2.77.7-3.2,1.64-7.4.93-10.63,4.38,2.84.6,5.18-1.43,7.37.32,1.37,2.59.76,5.42.54,8.22-.39,5-1,10-1.08,14.93,0,3.55.82,7.09,4.78,8.53,3.64,1.33,6.46-.41,9-2.85a17.4,17.4,0,0,0,2.24-2.68,41.82,41.82,0,0,0,4.81-9.82c1.55,1.07.48,2.64.75,4,.33,1.65-.65,3.54.93,4.95a9.26,9.26,0,0,0,5.39,6.82c-.45.17-.75.44-.57,1.18l5.17-.24-1.14-1L1046,562c1.69-.38,2.42-1.38,2-3.12l.08-1.07c1.46,3.73,5,4.68,8.18,6.08-.55.3-1.52-.21-1.74.93,1.31.21,2.58.8,3.43-.72,3.64-.11,7.24-.41,10.47-2.38,5.7-3.48,6.84-11.59.44-15.51-1.68-1-3.45-1.92-5.19-2.86a53,53,0,0,1-6.07-3.31c-4-2.87-3.78-5.74.39-8.82,2.61,1.44,5.25,1.18,7.9.15,2.51,1.21,1.83,3.39,1.48,5.41,3.75.37,4.84,0,5.52-1.78.79-2.06,0-4.41-2.33-5.9a35.12,35.12,0,0,0-3.89-1.92c.56-.24,1.37.12,1.7-.7-5.81-.83-9.05-.71-8.66.37l1.41.26c-4.69,1.37-8.91,3.37-11,8.2-.07-.14-.11-.36-.22-.42a2.65,2.65,0,0,0-.64-.19v6.09l.88-1a15.73,15.73,0,0,0,8.06,7.5c1.94.86,3.85,1.8,5.7,2.84,1.67,1,3.56,1.75,4,4-1.33,1-1.33,2,0,3a3.26,3.26,0,0,1-3,2.91,6.15,6.15,0,0,0-7,0c-3.55-.45-3.75-4.15-5.47-6-2.33-.28-3.25,1.22-4.37,2.39-.15-.41-.32-.81-1-.78C1047.83,556.74,1045.28,557.77,1047.12,559.06ZM967,558.88c-1.2-1.7-2.88-.61-4.35-.76-.84-.76-.74-1.8-.76-2.77a100.38,100.38,0,0,1,.68-13.86c.38-2.94.75-5.91-.18-8.85-1.62-5.13-5.77-6.94-10.48-4.39a16.16,16.16,0,0,0-5.9,5.91c-1.39,2.24-2.66,4.56-4,6.84-1.16.38-1,1.3-.9,2.2l-.33,1.64c-1.65-1.42-.1-3.44-.93-5,.26-4.11.46-8.23.82-12.33.78-9,1.64-18.05,2.51-27.07.16-1.69.43-3.32-1.48-4.25a1,1,0,0,0,.71-1.17l-4.24.22,1.14.94c-.59.8-1.87.81-2.38,2.64-1.09,20.82-2.23,42.36-3.36,64,2.27.22,3.88.44,5.25-.59.66-1.49,0-3.18,1.11-4.4.33,1.2-.29,2.54.77,4.08.2-1.95,1.06-3.54-.66-4.89a40.39,40.39,0,0,1,8-20.33,11.75,11.75,0,0,1,2.85-2.69c2.73-1.85,3.94-1.38,6,2-1.3,1.67-1.41,3.33.08,5,.44,5-.91,9.89-.65,14.86.15,3,.18,6,3,8-.14.07-.36.1-.42.22a3.49,3.49,0,0,0-.21.66h4.77l0-.55-1.78-.35c2-1.21,4.49-1.29,6.32-2.85a2.85,2.85,0,0,0,2.57-1.86C969.4,557.53,968.09,559.45,967,558.88Zm96-24.68c-1.25-1.66-2-1.6-2.85.23-1.75,3.29,1.37,2.36,2.48,3.4A6.15,6.15,0,0,0,1063,534.2Zm26.71,10.62c2-.59,4-1.19,6-1.75,4.08-1.15,7.4-3.25,9.23-7.25.17.43.42.73.86.58v-4l-.85.81c-1.33-3.25-4-4.92-7.14-6,.56-.22,1.37.13,1.72-.91h-8c.38,1,1.19.69,1.75.93-10.61,4.09-16.34,12.8-15.2,23.47.6,5.63,3.13,10.21,8.65,12.44s10.08.35,14.32-3.11a18.38,18.38,0,0,0,2.09-2.14c.65-.73,1.46-1.5.14-2.56-2.18,1-3.61,3.42-6.28,3.6a4.82,4.82,0,0,0-5.94,0c-5.06-1.88-6.74-5.91-7-10.87,1.21-.66,1.2-1.32,0-2,.93-1.85,2.58-.82,3.94-1,1,1.57,2.2,1.05,4.28.36Zm-102.41-17.7c-10.29,4.3-15.56,13-14.26,24,.67,5.58,3.11,10.21,8.81,12.16,5.42,1.85,10.08,0,14.16-3.63a18.18,18.18,0,0,0,4.51-6.48c.89-2.12,1.58-4.31,2.37-6.47.32.54-.22,1.56,1,1.74-.08-1.57.92-3.19-.79-4.4,0-1,0-2,0-3,1.59-1,.92-2.24.64-3.62-.88.55-.63,1.26-.81,1.84-1.62-5.52-4.46-10-10.18-12.06.15-.07.36-.1.42-.22a3.62,3.62,0,0,0,.23-.71h-8C985.94,527.19,986.69,526.92,987.25,527.12Zm69.56,24.67c2.45,5.11,3.49,5.54,7.13,3.49A18.57,18.57,0,0,0,1056.81,551.79Zm18-11.29c-1.49-.12-2.61.53-4,1.25a4.35,4.35,0,0,0,2.67,2.13A6.41,6.41,0,0,0,1074.84,540.5Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M851.83,551.29c-1.88.12-1.57,1.82-2.13,2.92-3.38,6.68-7.48,12.56-15.74,13.61a6.54,6.54,0,0,0-6.93,0c-6.64-1.08-10.63-5.4-12.54-11.38-3-9.52-1.12-18.43,5-26.25,8.43-10.72,25.88-10.25,31.23,4.53.21.59.12,1.36,1.17,1.8.39-7.81.75-15.52,1.15-23.23.25-4.81.6-9.61.84-14.42a6.49,6.49,0,0,1,4.67-6.38,9.91,9.91,0,0,1,9.44,1.43,3.85,3.85,0,0,1,1.42,3.58c-.79,5.89-.64,11.91-2.36,17.67-.05-.32-.09-.66-.16-1-.13-.65-.75-.16-.15-.44s-.8-.78-.74-.19c.63,2.11-1.06,4.41.82,6.41-.66,9.45-1.13,18.92-1.17,28.39,0,2.09-.4,4.28.6,6.31,2.55-.7,1.59-2.7,1.64-4.18a31.26,31.26,0,0,1,3.93-14.76c4.93-8.65,12.17-13.41,22.39-12.74,1.22-1.11.7-2.54.79-3.8.39-5.81.65-11.62,1.09-17.42a18.76,18.76,0,0,1,1.14-5.84c1.13-2.68,3.59-3.81,6.45-3.94s5.69.26,7.6,2.81c1.11,1.47.76,3.2.56,4.83-.78,6.43-1.7,12.85-2.4,19.29a216,216,0,0,0-1.42,35.48c1.17-.2,2.09-.4,3-.5a4.18,4.18,0,0,1,4.71,2.88c.77,2.08,1.1,4.38-.87,6-4.09,3.36-8.75,5.42-14.16,5.23a6.08,6.08,0,0,1-5.73-4.08,7.13,7.13,0,0,0-1.43-3.06c-3.24,2.69-5.82,6.66-10.62,7a3.62,3.62,0,0,0-4.93,0c-2.79.08-4.38-2-6.56-3.66a44.6,44.6,0,0,1-8,3.38c-6.77,1.79-10.09-.41-11.38-7.57,1.13-3.15,1.17-4.65.3-9.35ZM897,557h.86l.08,2c-1.34.67-1,1.54-.53,2.78l.76-1.08a8.74,8.74,0,0,0,3,3.21,1.61,1.61,0,0,0-.43.24.66.66,0,0,0-.15.4,4.77,4.77,0,0,0,4,.13c-.41-.85-1.18-.62-1.77-.8,2.89-1.73,6.89-1.58,9.22-5.24-4.91.83-4.91.83-7.74,0a21.78,21.78,0,0,1-1.11-6.77c-.34-9.17.47-18.31,1.24-27.42.3-3.59.06-7.32,1.43-10.8.59,1.15-.45,2.69,1.45,4.3-.83-2.74.82-5-1.19-6.93-.05-2.11-.27-4.25.84-6.2.39,1.19-.44,2.61,1,4.09-.24-2.28.87-4.22-.87-5.89l0-1a3.58,3.58,0,0,0,0-5l-1.47-.78c.44-.17.8-.4.71-1a7.28,7.28,0,0,0-4.14.16l1.06.83a4.63,4.63,0,0,0-2.46,3.95c-.21,4.44-.67,8.87-1,13.31-.34,5.08-.63,10.16-1,15.58l-5.18-1.9c.56-.24,1.38.11,1.76-.93h-8c.37,1,1.19.69,1.75.92-9.55,3-14.8,9.56-16.48,19.25a10.61,10.61,0,0,1-.67,1.83c-.33-.87.34-2-.9-2.79v10.15c1-.48.72-1.26.94-1.83a5.58,5.58,0,0,1,.62,1.31c.63,4,2.1,7.55,6.29,8.64s7.07-1.82,9.79-4.53a6.6,6.6,0,0,0,.64-.76l5.42-7.59A6.76,6.76,0,0,1,896,555,1.63,1.63,0,0,0,897,557Zm-32.15-55.3c.53,1.14-.42,2.64,1.5,4.46-.91-3,.74-5.24-1.27-7.14.39-1.88-1.37-2.06-2.29-2.9.44-.17.73-.43.58-1a8.11,8.11,0,0,0-4,.18c.52.86,1.24.6,1.79.79l-3,2.21c-.16-.44-.38-.8-1.34-.67.85,1.38-.9,3.15,1.09,4.34.08,10.46-1,20.86-1.46,31.29-.36,8-.66,15.91-.48,23.87.06,2.74.44,5.3,3.17,6.78l-.6.66c.41.74,1.11.4,1.67.4.77,0,1.62.26,2.29-.38-.37-.76-1.13-.53-1.73-.71,2.91-1.57,6.57-1.78,9.22-4.93-2.89-.59-5.38,1.7-7.7-.31-1.09-2.27-1.13-4.76-1.17-7.27-.19-13.18,1-26.29,2.28-39.39C863.74,508.58,863.4,505,864.85,501.7Zm-27.18,25.48c.15-.07.35-.1.43-.21a5.69,5.69,0,0,0,.32-.77h-7.91c.36,1.06,1.16.67,1.7.9-10.64,4.36-16,13.7-14.26,24.92s12.89,15.57,21.72,8.6a19.93,19.93,0,0,0,6.39-9.33c.65-1.86,1.18-3.75,1.76-5.63.27.56-.07,1.37,1,1.88.18-3.08.58-6-.22-9-.16-.6.19-.08-.44.21l-.28,1.44C846.4,534.38,843.79,529.41,837.67,527.18Zm16.54,30.08.49.12V545.63h-.49Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1022,476.25c4.58,2.38,8.1,6.19,12.38,9,13.6,9,28.59,13.69,44.6,15.67,7.08.88,14.15,1.85,21.3,2.16,8,.35,10.5,4.19,7.71,11.88a9.7,9.7,0,0,1-7.38,2.23c-16.33-.84-32.44-3.07-48.13-7.73-10.6-3.15-20.13-8.54-29.18-14.82l-3.08-2.17c-3.22,2.59-6.47,5.11-9.61,7.75-6.93,5.8-15,9.06-23.75,10.9a121.32,121.32,0,0,1-21.71,2.91l-1.5,0c-5.41,0-8.54-2.43-8.68-6.77s3-7.07,8.21-7.34c3.32-.16,6.65-.29,10-.67,3.46-.4,6.91-1,10.33-1.66,11.66-2.18,20.6-8.86,28.36-17.4,1.56-1.71,2.82-3.73,5.25-4.4l0,.39A3.93,3.93,0,0,0,1022,476.25Zm-44.66,26.9c-5.48,1.71-11.3,1.05-16.65,2.05-1.12,1.53-1.09,2.67.3,3.88H972c1.68,1.75,3.56.75,5.69.64-1.07-1.07-2.14-.52-3-.87a3.73,3.73,0,0,1,2.33-.72,60.39,60.39,0,0,0,40.1-19.92c.73-.8,1.25-2,2.71-2l2.73,2.08c12.31,9.42,25.86,16.22,41.11,19.39,5.5,1.14,11,2.16,16.55,3.24-.8.41-2-.46-2.76,1.43,1.64-.91,3.35.66,4.51-1.25,6,.47,11.91.88,17.86,1.43,2.09.2,4.06.51,4.73-2.11-.44-2.61-2.42-2.31-4.24-2.48-7.58-.73-15.23-.8-22.66-2.75.83-.44,2.08.39,2.75-1.11-1.59.21-3.23-.91-4.42.9-1.5.06-3,.23-4.32-.79.54-.31,1.52.2,1.75-.93-1.29-.23-2.55-.79-3.42.68-1.2.1-2.39.18-3.37-.73.55-.33,1.54.2,1.79-.93-1.28-.26-2.52-.8-3.42.64a18.3,18.3,0,0,1-2.46-.24c-14.54-3.36-27.32-10.25-39-19.43-1.41-1.12-2.56-2.65-4.65-3.07-1.56.53-2.45,2-3.62,3.15-2.74,2.68-5.4,5.45-8.28,8a48.13,48.13,0,0,1-28,11.68c-1-1.57-2.22-1-4.55-.33Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1064,583.13a4.68,4.68,0,0,0,3.58,0c6.42-2.46,10.32.3,10.45,7.18.09,4.63,0,9.27,0,14-2.24,1-4.31.53-6.57.43-1.24-5.14.49-10.37-1.07-15.17-1.77-1.15-3.27-.94-5.22.34v14.6a20.45,20.45,0,0,1-6.18.28c-1.27-.91-.92-2.16-.92-3.27,0-5.31,0-10.62,0-15.93,0-.84-.54-2.06,1-2.35A3.57,3.57,0,0,0,1064,583.13Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M971.94,584c.08,3.15.15,6.29.22,9.44.05,1.81-.18,3.69,1.37,5.13,1.51.73,2.87.38,4.54-.93,0-3.66-.06-7.62,0-11.58,0-1-.81-2.39.94-2.86a3.59,3.59,0,0,0,4.92-.06c.5.07,1,.19,1,.81,0,6.79,0,13.58,0,20.54-2.32.67-4.65,1.07-6.41,0s-2.42.49-3.62.33a3.8,3.8,0,0,0-5,0l.07.37c-3.21-.85-4.62-3.38-4.78-6.25-.29-5.1,0-10.23,0-15.34,0-.13.51-.26.78-.39C967.83,584.82,970,583.67,971.94,584Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M860,583.13c5.88,2.26,5.23,7.2,5.21,12.13-4.45,1-8.78,0-13,.7,1.67,4.63,4.06,4.89,12.37,1.39.85,1.9.38,3.85.39,5.75-1.41,1.45-3.21,1.72-5,2.07l.06-.36a6.93,6.93,0,0,0-7,0l.07.38c-3.86-1.07-7.09-2.8-7.87-7.21a8.52,8.52,0,0,0,0-7.93c.38-3.65,2.46-5.86,5.89-6.9A9.87,9.87,0,0,0,860,583.13Zm-8.33,7.45a13.74,13.74,0,0,0,6.21-.05c.59-2.16-.65-3.11-2.2-3.3C853.73,587,852.1,587.71,851.65,590.58Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M947,583.19a5.16,5.16,0,0,1,4.11,5,126,126,0,0,1-.07,16.59c-2.15.23-4.32.78-6-.18-1.83-1.08-2.76.3-4.08.58l0-.38a4,4,0,0,0-5,0l.06.39c-1.89-.84-3.43-2-3.82-4.2a5,5,0,0,0,0-5.9c.82-2.78,3.19-3.53,5.56-4.15,2-.53,4.11-.82,6.6-1.3-3.73-3.42-7.34-.9-11-.55-.09-2.1-1.33-4.1.71-5.83A21.57,21.57,0,0,0,947,583.19Zm-7.27,16.46a3.82,3.82,0,0,0,4.21-1c.43-1.21.66-2.44-.35-3.58a5.65,5.65,0,0,0-4.48,1.44A2.45,2.45,0,0,0,939.7,599.65Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1025.17,595c.67-2.62,2.88-3.42,5.07-4s4.4-.9,7-1.41c-3.7-3.47-7.34-.82-11.14-.56.16-2.14-1.31-4.19.92-5.84a21.49,21.49,0,0,0,12.92,0,5.15,5.15,0,0,1,4,5,123.64,123.64,0,0,1-.09,16.43c-2.28.2-4.46.91-6.38-.18-1.62-.92-2.39.47-3.56.69l0-.39a4,4,0,0,0-5,0l.06.39c-2-.79-3.51-1.95-3.9-4.2A4.79,4.79,0,0,0,1025.17,595Zm11.91,3.68c0-1.18.42-2.29-.53-3.63-2.29,0-4.74-.11-5.21,3.22C1032.94,600.64,1034.71,600.18,1037.08,598.71Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M892.91,589.26c-2.78-1-5.54-2.25-8.78-.72,1,2.33,3.33,1.83,5,2.35,2.4.75,4.86,1.25,5.58,4.18a3.8,3.8,0,0,0,.06,4.89c-.84,3-3.15,4.28-5.83,5.19l.06-.39a9.21,9.21,0,0,0-8,0l.07.38-3.74-1.34c-.87-2.17-.35-4.27-.36-6.7,3.75,1.3,7,3.94,10.88,2.16.1-1.69-1-1.81-1.9-2a34.1,34.1,0,0,1-4.35-1c-2.7-1.08-4.44-2.82-4.67-5.84a6.5,6.5,0,0,1,3.94-6.88c4.35-1.94,8.82-2.3,13.07.5C892.11,585.48,893.44,587.55,892.91,589.26Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M907,583.07c1.14-.51,1.06-1.54,1.1-2.53s.11-1.95.18-3.07c2.11-1,4.2-.43,6.23-.47,1.07,1.81.29,3.76.88,5.27,1.64,1.18,3.46.05,5,1,.88,1.45.38,3,.23,4.37-1.71,1.18-3.57.08-5.29,1.25-.14,3.41-.86,6.93.34,9.8,1.83,1.92,3.31,0,5,.83-.19,1.93,1.65,4.43-1.71,5.62l.06-.36a5.24,5.24,0,0,0-6.06,0l.08.37c-3.64-1-4.82-3.7-4.93-7.1-.08-2.31,0-4.63,0-6.95,0-1.13.19-2.36-1.08-3.06Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1097,605.14c-3.51-1.2-4.59-4-4.74-7.33-.12-2.78,0-5.58-.1-8.36-.13-1.25-1.68-1-2-2-1.32-3.54,2.29-5.53,2.67-8.53,2.07-1.17,4.14-1.4,6.2,0l.74,3.3c1.51,1.15,3.34,0,4.94,1a6.92,6.92,0,0,1-.11,4.84l-4.6.29a18.77,18.77,0,0,0,0,10.25c1.57,1.86,3.06.37,4.42.55,1.39,1.49.59,4.62-1.48,6l.07-.36a5.26,5.26,0,0,0-6-.07Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1006,584c1.67,1.38,2.56-1.15,4-.79,1,1.17,2,1.18,2.92-.06,2.23,1.85.3,4.18,1,6.31-2.38,1.19-4.86-.25-7.21,1.18-1.48,3.15.07,6.89-.85,10.37-1.37,1.19-2.51,3.23-4.62,1.36V584Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M833,583.16c2.22,1.86.15,4.2,1.25,6.25-2.63,1.19-5.08-.1-7.42,1.15-1.48,3.23,0,7-.87,10.45-1.36,1.21-2.51,3.22-4.62,1.36V584H826c1.67,1.37,2.57-1.17,4-.8C831,584.39,832,584.39,833,583.16Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1006,584h-4.7v18.37c2.11,1.87,3.25-.17,4.62-1.36a6.49,6.49,0,0,1-.25,3.59,16.11,16.11,0,0,1-6.06-.08V583C1001.88,583.48,1004.18,581.66,1006,584Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M826,584h-4.7v18.37c2.11,1.86,3.26-.15,4.62-1.36a5.26,5.26,0,0,1-.39,3.62,15.73,15.73,0,0,1-5.93-.13V583C821.87,583.48,824.16,581.66,826,584Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M832.86,513.7c-.62,2-1.27,4.09-1.84,6.14-.35,1.24-1,1.62-2.17,1-.5-12.86,0-17.57,2.59-19.85,1.2,2.5.28,4.91.21,7.25,0,1.56-1.21,3.16.22,4.66C832.32,513,832.73,513.18,832.86,513.7Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M824.28,504.79c.37,2.25-.64,3.83,0,5.44.59.94,2,.17,2.52,1.21-.41,1.24-1.74.57-2.46,1.16-1.48,5.17-1.48,5.17,2.08,7.63,0,.13.09.34,0,.37a5.58,5.58,0,0,1-3.29.93c-4.34-2.15-.56-6.91-3.33-10C823,510.56,820.25,506,824.28,504.79Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M832.86,513.7c-.13-.52-.54-.67-1-.76a4.57,4.57,0,0,1,3.79-3c4,1.82,1.47,5.5,2.23,8.32l2,1.62c-1.37,1.58-2.8,1.33-4.36,1-1.36-2.37,0-5.1-.69-7.71Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M845,515.79l-1.73.59c.11,2.8,1.87,2.92,3.75,2.88,0,.5.18.79.73.74-1.45,2.24-3.48.7-5,1.16-3.27-4.79-3-6.71,1.16-10.23a1.35,1.35,0,0,1,1.12.94l-1.14,1c-1.64,1.81-.4,2,1.13,2Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1040,583.22a21.49,21.49,0,0,1-12.92,0C1031.35,582,1035.66,581.45,1040,583.22Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M947,583.19a21.57,21.57,0,0,1-12.92,0C938.35,582,942.66,581.45,947,583.19Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M845,511.87a1.35,1.35,0,0,0-1.12-.94c2.84-1,2.84-1,5.22,1.17-.08,2.61-1.88,3.38-4.11,3.69v-.87a1.71,1.71,0,0,1,.08-.81C846.48,513.31,846.59,512.56,845,511.87Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M860,583.13a9.87,9.87,0,0,1-9,0C854,581.6,857,581.92,860,583.13Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1007.84,541.89c-.09,3.07,1,6.23-.72,9.17-.38-.58,0-1.54-.93-1.86q.51-3.66,1-7.32l.32,0Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M851.83,551.29l.6-.67c.87,4.7.83,6.2-.3,9.35A32.79,32.79,0,0,1,851.83,551.29Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M968,554c-.24.47-.63.69-1.72.6-.19-2.57-.55-5.19.63-7.79C967.69,549.13,966,551.84,968,554Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1099,579c-2.06-1.45-4.13-1.22-6.2,0l.09-1.49c1.9-1.08,3.84-.16,5.42-.5A2,2,0,0,1,1099,579Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M944.86,526c-1.67-2.39-.58-5-.77-7.66,1.34.86.69,2,1,2.9Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M845.14,590a8.52,8.52,0,0,1,0,7.93A14.83,14.83,0,0,1,845.14,590Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M866.85,520c-1.88-2-.19-4.3-.82-6.41-.06-.59,1.34-.1.74.19s0-.21.15.44c.07.32.11.66.16,1Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M827,567.82a6.54,6.54,0,0,1,6.93,0A16.36,16.36,0,0,1,827,567.82Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1057,567.89a6.38,6.38,0,0,1,6.93-.09A18,18,0,0,1,1057,567.89Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1025.17,595a4.79,4.79,0,0,1,0,5.94A8.38,8.38,0,0,1,1025.17,595Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M983,567.89a4.75,4.75,0,0,1,5.94,0A14,14,0,0,1,983,567.89Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1088,567.84a4.78,4.78,0,0,1,5.94,0A13.68,13.68,0,0,1,1088,567.84Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M971.94,584c-2-.33-4.11.82-5.89-.8C968,583.31,970.23,581.86,971.94,584Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M892.91,589.26c.53-1.71-.8-3.78,1-5.24.81,1.65.54,3.39.26,5.08C894,590,893.42,589.85,892.91,589.26Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M932.23,595.05a5,5,0,0,1,0,5.9A9.59,9.59,0,0,1,932.23,595.05Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1064,583.13a3.57,3.57,0,0,1-4.93.06A13.84,13.84,0,0,1,1064,583.13Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M878,567.82a3.62,3.62,0,0,1,4.93,0A9.17,9.17,0,0,1,878,567.82Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M907,583.07v5C905.45,586.15,905.45,584.93,907,583.07Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M894.79,600a3.8,3.8,0,0,1-.06-4.89A7.33,7.33,0,0,1,894.79,600Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M984,583.14a3.59,3.59,0,0,1-4.92.06A13.13,13.13,0,0,1,984,583.14Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M970,604.81a3.8,3.8,0,0,1,5,0l-.91.41Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1016,567.83a3.6,3.6,0,0,1,4.93,0A9.17,9.17,0,0,1,1016,567.83Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1091.32,548.18l-.84-.6c1.27-.92,2.4-1,3.47.22Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M847.73,520c-.55,0-.74-.24-.73-.74.27-.87.82-1.69,1.64-.81S848.72,519.87,847.73,520Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1013,583.15c-1,1.24-1.92,1.23-2.92.06A4.5,4.5,0,0,1,1013,583.15Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1077,531.94c-.33.66-.75,1-1,0a1.5,1.5,0,0,1,.74-1.9Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M943.91,557a1.45,1.45,0,0,1-.87-1.9c.27-1,.69-.62,1,0Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M833,583.16c-1,1.23-1.93,1.23-2.92,0A4.49,4.49,0,0,1,833,583.16Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M968.09,550.83c.59,1.07,1.64,2.16-.1,3.15C968,552.93,968.06,551.88,968.09,550.83Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1022,476.25a3.93,3.93,0,0,1-5,0l4.07-.41A1.84,1.84,0,0,1,1022,476.25Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M853,604.79a6.93,6.93,0,0,1,7,0A25.23,25.23,0,0,1,853,604.79Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M913,604.78a5.24,5.24,0,0,1,6.06,0A18.4,18.4,0,0,1,913,604.78Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1097,604.75a5.26,5.26,0,0,1,6,.07A18.07,18.07,0,0,1,1097,604.75Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M936,604.76a4,4,0,0,1,5,0A11.63,11.63,0,0,1,936,604.76Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1029,604.78a4,4,0,0,1,5,0A11.43,11.43,0,0,1,1029,604.78Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M881,604.77a9.21,9.21,0,0,1,8,0l-2,.42h-4Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1056.81,551.79a18.57,18.57,0,0,1,7.13,3.49C1060.3,557.33,1059.26,556.9,1056.81,551.79Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1034.11,545q-.12,6-.25,12c-1.58-1.41-.6-3.3-.93-4.95-.27-1.32.8-2.89-.75-4l.92-4C1033.75,544.07,1033.86,544.62,1034.11,545Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1058,531.18a6.79,6.79,0,0,1,7.9.15C1063.28,532.36,1060.64,532.62,1058,531.18Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1065,559.9a6.39,6.39,0,0,1-7,0A6.15,6.15,0,0,1,1065,559.9Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1063,534.2a6.15,6.15,0,0,1-.37,3.63c-1.11-1-4.23-.11-2.48-3.4Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M940.76,544.84l-1.08,3.58c-.7-3-1.14-5.83.15-8.59C940.66,541.4,939.11,543.42,940.76,544.84Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1066.71,527.14l-5.55-.07-1.41-.26c-.39-1.08,2.85-1.2,8.66-.37C1068.08,527.26,1067.27,526.9,1066.71,527.14Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M968,561c-.47-1.31-1.58-.86-2.51-.9s-2,.21-2.5-1a8.18,8.18,0,0,0,4-.17c1.12.57,2.43-1.35,3.59.24A2.85,2.85,0,0,1,968,561Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1097.77,527.11l-4.52,0c-.56-.24-1.37.11-1.75-.93h8C1099.14,527.24,1098.33,526.89,1097.77,527.11Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M992.72,527.15l-5.47,0c-.56-.2-1.31.07-1.83-.9h8a3.62,3.62,0,0,1-.23.71C993.08,527.05,992.87,527.08,992.72,527.15Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1074.84,540.5a6.41,6.41,0,0,1-1.31,3.38,4.35,4.35,0,0,1-2.67-2.13C1072.23,541,1073.35,540.38,1074.84,540.5Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1097,558.83a6,6,0,0,1-5.94,0A4.82,4.82,0,0,1,1097,558.83Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1046,562c-.37-1-1.21-1-2-.93s-1.64-.09-2-1.07c1.78.15,3.64.75,5.11-.9h.49l.43-.23C1048.41,560.58,1047.68,561.58,1046,562Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1007.84,541.89l-.32,0-.32,0-.84-6C1008.29,537.57,1008.29,537.57,1007.84,541.89Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1050.15,535.27c0,1.48,0,3,0,4.43l-.88,1v-6.09a2.65,2.65,0,0,1,.64.19C1050,534.91,1050.08,535.13,1050.15,535.27Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M959.27,563.85l2.4,0,1.78.35,0,.55h-4.77a3.49,3.49,0,0,1,.21-.66C958.91,564,959.13,563.92,959.27,563.85Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1039.25,563.86l3.46,0,1.14,1-5.17.24C1038.5,564.3,1038.8,564,1039.25,563.86Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M941.68,496.18h-2.39l-1.14-.94,4.24-.22A1,1,0,0,1,941.68,496.18Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1033.18,535.34l-.25,1.65c-1.79-1.21-.67-2.84-.3-4.42C1032.81,533.5,1033,534.42,1033.18,535.34Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M956.85,536a8.81,8.81,0,0,1,.08,5C955.44,539.36,955.55,537.7,956.85,536Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1015.76,527.13l-.28.09-.28-.12c-.89-.31-2,.29-2.77-.7,1.28-.7,2.59-.38,3.87-.3C1016.57,526.72,1016.2,527,1015.76,527.13Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1104.9,535.82c0-.89,0-1.77,0-2.66l.85-.81v4C1105.32,536.55,1105.07,536.25,1104.9,535.82Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M939.91,557.81A.6.6,0,0,1,940,557c1.72,1.35.86,2.94.66,4.89C939.62,560.35,940.24,559,939.91,557.81Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1048,558.84l-.43.23h-.49c-1.84-1.29.71-2.32.11-3.53.63,0,.8.37,1,.78l-.06,1.46Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1002.84,546.68l.25-2.66c1.71,1.21.71,2.83.79,4.4C1002.62,548.24,1003.16,547.22,1002.84,546.68Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1056.3,563.85l1.69.21c-.85,1.52-2.12.93-3.43.72C1054.78,563.64,1055.75,564.15,1056.3,563.85Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1040.1,556a.66.66,0,0,1-.16-.84c.23-.88-.24-1.88.68-2.85C1041,553.72,1041.66,555,1040.1,556Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M967,558.88a8.18,8.18,0,0,1-4,.17l-.36-.93C964.09,558.27,965.77,557.18,967,558.88Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1088,545l1.65-.22,2.63.58C1090.21,546.09,1089,546.61,1088,545Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1003.07,541l-.17-1.78c.18-.58-.07-1.29.81-1.84C1004,538.75,1004.66,540,1003.07,541Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1063,534.2l-2.85.23C1061,532.6,1061.7,532.54,1063,534.2Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1067.92,554a2.9,2.9,0,0,1,0,3C1066.59,556,1066.59,555,1067.92,554Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1084.07,548a2.22,2.22,0,0,1,0-2C1085.27,546.67,1085.28,547.33,1084.07,548Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M942,541a2.41,2.41,0,0,1-.9,2.2C941,542.3,940.83,541.38,942,541Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M854.21,557.26V545.63h.49v11.75Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M896.15,548l.94-2.92c.66,0,.82.53,1.1,1L897.86,557H897C896.47,554,898.06,550.87,896.15,548Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M896.15,548c1.91,2.83.32,6,.85,9a1.63,1.63,0,0,1-1-2,6.76,6.76,0,0,0-1.11-4.2A5.1,5.1,0,0,1,896.15,548Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M872.1,548.2l0,5.53c-.22.57.05,1.35-.94,1.83V545.41C872.44,546.19,871.77,547.33,872.1,548.2Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M847.82,545.66l.06-5.43.28-1.44c.63-.29.28-.81.44-.21.8,2.93.4,5.88.22,9C847.75,547,848.09,546.22,847.82,545.66Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M837.67,527.18l-5.46-.08c-.54-.23-1.34.16-1.7-.9h7.91a5.69,5.69,0,0,1-.32.77C838,527.08,837.82,527.11,837.67,527.18Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M893.74,527.13h-4.49c-.56-.23-1.38.12-1.75-.92h8C895.12,527.24,894.3,526.89,893.74,527.13Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M864.85,501.7l.23-2.68c2,1.9.36,4.18,1.27,7.14C864.43,504.34,865.38,502.84,864.85,501.7Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M905.82,513.65l.26-2.63c2,1.91.36,4.19,1.19,6.93C905.37,516.34,906.41,514.8,905.82,513.65Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M906.92,504.82l.17-1.8c1.74,1.67.63,3.61.87,5.89C906.48,507.43,907.31,506,906.92,504.82Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M862.79,496.12l-1.59,0c-.55-.19-1.27.07-1.79-.79a8.11,8.11,0,0,1,4-.18C863.52,495.69,863.23,496,862.79,496.12Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M905.69,496.18h-2.37l-1.06-.83a7.28,7.28,0,0,1,4.14-.16C906.49,495.78,906.13,496,905.69,496.18Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M858.17,498.31l-.25,3.67c-2-1.19-.24-3-1.09-4.34C857.79,497.51,858,497.87,858.17,498.31Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M907.11,502c0-1.68,0-3.36,0-5A3.58,3.58,0,0,1,907.11,502Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M859.15,563.92l1.63,0c.6.18,1.36,0,1.73.71-.67.64-1.52.39-2.29.38-.56,0-1.26.34-1.67-.4Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M901.15,563.92l1.63,0c.59.18,1.36,0,1.77.8a4.77,4.77,0,0,1-4-.13.66.66,0,0,1,.15-.4A1.61,1.61,0,0,1,901.15,563.92Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M897.94,559l.23,1.7-.76,1.08C897,560.55,896.6,559.68,897.94,559Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M972,509.08l2.69-.23c.86.35,1.93-.2,3,.87C975.58,509.83,973.7,510.83,972,509.08Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1077.68,505.16,1076,505c1.19-1.81,2.83-.69,4.42-.9C1079.76,505.55,1078.51,504.72,1077.68,505.16Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1080.24,510.89l1.75.18c-1.16,1.91-2.87.34-4.51,1.25C1078.2,510.43,1079.44,511.3,1080.24,510.89Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1071.69,504.16l-1.67-.25c.87-1.47,2.13-.91,3.42-.68C1073.21,504.36,1072.23,503.85,1071.69,504.16Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M979,502.94l-1.7.21-2.85-.54C976.77,502,978,501.37,979,502.94Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1066.65,503.18l-1.63-.29c.9-1.44,2.14-.9,3.42-.64C1068.19,503.38,1067.2,502.85,1066.65,503.18Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M851.65,590.58c.45-2.87,2.08-3.58,4-3.35,1.55.19,2.79,1.14,2.2,3.3A13.74,13.74,0,0,1,851.65,590.58Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M939.7,599.65a2.45,2.45,0,0,1-.62-3.12,5.65,5.65,0,0,1,4.48-1.44c1,1.14.78,2.37.35,3.58A3.82,3.82,0,0,1,939.7,599.65Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1037.08,598.71c-2.37,1.47-4.14,1.93-5.74-.41.47-3.33,2.92-3.18,5.21-3.22C1037.5,596.42,1037,597.53,1037.08,598.71Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M845,511.87c1.6.69,1.49,1.44.07,2.24a1.51,1.51,0,0,1-1.21-1.2Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M843.85,512.91a1.51,1.51,0,0,0,1.21,1.2,1.71,1.71,0,0,0-.08.81C843.45,514.9,842.21,514.72,843.85,512.91Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M979.05,543a13.38,13.38,0,0,1,2-8c2.84-5.27,8.78-5.75,12.65-1.13a14.45,14.45,0,0,1,3.06,7.21,24.92,24.92,0,0,1-1.48,13.6c-1,2.44-2.14,4.88-5.26,5.27-1.3-1.5-2.62-1.48-4,0-5.28-1.74-6.68-6-7-10.88C980.36,546.49,980.36,545.52,979.05,543Zm4.07,7.78c1.8,2,1.88,6.12,6.07,5,2.89-2,2.36-5.46,3.69-8,.24.53-.12,1.32,1.13,1.83,0-2.45,0-4.73,0-7,0-.35.27-1-.53-1l-.6.64c-1.59-2.72-1.4-7-5.82-7.2-2.44,1-2.49,3.43-3.71,5.05-2.16,1-1.58,2.43-.48,3.88V548c-1.43,1-.86,2.23-.58,3.76Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M979.05,543c1.31,2.51,1.31,3.48,0,6A12.73,12.73,0,0,1,979.05,543Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M986,559.87c1.33-1.43,2.65-1.45,4,0A4.85,4.85,0,0,1,986,559.87Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1085.12,538c.63-3,2-5.49,4.94-6.81a4.94,4.94,0,0,0,5.9,0,2.63,2.63,0,0,1,2,2.84c-1.36,1-1.34,2,0,3-1.32,3.74-4.51,4.52-7.91,4.95-.69-1.62-2.32-.52-3.35-1.17S1086.5,538.46,1085.12,538Zm5.84-2c-1,.31-1.13.9-.49,1.85l1.55-.94c1-.19,1.81-.55,1.67-1.85A1.81,1.81,0,0,0,1091,536Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1085.12,538c1.38.43.48,2.11,1.51,2.73s2.66-.45,3.35,1.17c-1.83.63-3.66,1.32-5.74.71A6,6,0,0,1,1085.12,538Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1096,531.18a4.94,4.94,0,0,1-5.9,0C1092,529.92,1094,529.54,1096,531.18Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1097.89,537c-1.29-1-1.31-2,0-3A3.32,3.32,0,0,1,1097.89,537Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1034.11,545c-.25-.39-.36-.94-1-.85L1033,542C1035.37,542.65,1035.46,542.9,1034.11,545Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M879.08,543c2-10.86,9.72-15.39,19.88-11.28-1.62,9-4.58,17.45-11.38,24-4.14,4-7.07,2.92-8.56-2.77A11.63,11.63,0,0,0,879.08,543Zm14.83-8.67c-1.34-1.81-2.42-1.82-3.83,0-6.15,2.9-9.2,11.72-6.11,19A37,37,0,0,0,893.91,534.35Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M879.08,543a11.63,11.63,0,0,1-.06,10C877.59,549.66,878,546.34,879.08,543Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M898.19,546.07c-.28-.42-.44-1-1.1-1-.09-1.25,1-1.75,1.5-3.12C899.09,543.83,899.38,545.06,898.19,546.07Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M831,559.91c-5-1.39-6.43-5.37-7-9.92a9.37,9.37,0,0,0,.08-9c-.22-2.45.81-4.57,2-6.55,2.77-4.58,8-5.1,11.81-1.26a11.2,11.2,0,0,1,2.4,3.74c2.52,6.4,1.91,12.7-.74,18.86-.85,2-2.19,3.73-4.62,4.07C833.65,558.43,832.33,558.43,831,559.91ZM832,535a16.06,16.06,0,0,0-3.68,15c.72,2.61,1.47,5.56,5.33,6.06,4.35-3.91,3.76-9.17,3.36-14.18C836.73,538.94,835.72,536,832,535Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M824.12,541a9.37,9.37,0,0,1-.08,9C822.91,547,823.36,544,824.12,541Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M831,559.91c1.31-1.48,2.63-1.48,4,0A4.89,4.89,0,0,1,831,559.91Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M992.88,547.76c0-1.84,0-3.68,0-5.52l.6-.64c.8,0,.53.63.53,1,0,2.28,0,4.56,0,7C992.76,549.08,993.12,548.29,992.88,547.76Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M982.85,548l.27,2.76-.85,1C982,550.26,981.42,549.06,982.85,548Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M983.33,540.09l-.48,3.88C981.75,542.52,981.17,541.14,983.33,540.09Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1091,536a1.81,1.81,0,0,1,2.73-.94c.14,1.3-.67,1.66-1.67,1.85A1.15,1.15,0,0,0,1091,536Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1091,536a1.15,1.15,0,0,1,1.06.91l-1.55.94C1089.83,536.89,1090,536.3,1091,536Z",
    transform: "translate(-813.08 -475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M893.91,534.35l-3.83,0C891.49,532.53,892.57,532.54,893.91,534.35Z",
    transform: "translate(-813.08 -475)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldlogo);
export default __webpack_public_path__ + "static/media/oldlogo.99eb4fdeeda47035f6b977ffd46f0a2e.svg";
export { ForwardRef as ReactComponent };